import EnumType from "@/app/shared/EnumType.js";

const values = {
  Ore: 0, 
  Acid: 1,
  Sterile: 2,
  Standby : 3
};

export default EnumType.generate(values, "Material.");